var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewSystemFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3981",
    d: "M14.6663 12C14.6663 13.4727 13.4724 14.6666 11.9997 14.6666C10.5269 14.6666 9.33301 13.4727 9.33301 12C9.33301 10.5272 10.5269 9.33331 11.9997 9.33331C13.4724 9.33331 14.6663 10.5272 14.6663 12Z",
    fill: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 6942"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3983",
    d: "M14 2C14 3.10457 13.1046 4 12 4C10.8954 4 10 3.10457 10 2C10 0.895431 10.8954 0 12 0C13.1046 0 14 0.895431 14 2Z",
    fill: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3984",
    d: "M14 22C14 23.1046 13.1046 24 12 24C10.8954 24 10 23.1046 10 22C10 20.8954 10.8954 20 12 20C13.1046 20 14 20.8954 14 22Z",
    fill: "#7B3DE9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 6943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3983_2",
    d: "M21.6596 8.73199C20.703 9.28427 19.4798 8.95652 18.9275 7.99993C18.3752 7.04335 18.703 5.82017 19.6596 5.26788C20.6161 4.7156 21.8393 5.04335 22.3916 5.99993C22.9439 6.95652 22.6161 8.1797 21.6596 8.73199Z",
    fill: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3984_2",
    d: "M4.33924 18.732C3.38265 19.2843 2.15947 18.9565 1.60719 17.9999C1.0549 17.0433 1.38265 15.8202 2.33924 15.2679C3.29582 14.7156 4.519 15.0433 5.07129 15.9999C5.62357 16.9565 5.29582 18.1797 4.33924 18.732Z",
    fill: "#7B3DE9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 6944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3983_3",
    d: "M4.33947 5.26789C5.29606 5.82018 5.62381 7.04336 5.07152 7.99994C4.51924 8.95653 3.29606 9.28428 2.33947 8.73199C1.38289 8.17971 1.05514 6.95653 1.60742 5.99994C2.15971 5.04336 3.38289 4.71561 4.33947 5.26789Z",
    fill: "#7B3DE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3984_3",
    d: "M21.6598 15.2679C22.6164 15.8202 22.9441 17.0434 22.3918 17.9999C21.8396 18.9565 20.6164 19.2843 19.6598 18.732C18.7032 18.1797 18.3754 16.9565 18.9277 15.9999C19.48 15.0434 20.7032 14.7156 21.6598 15.2679Z",
    fill: "#7B3DE9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 6941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9993 5.33331C12.7357 5.33331 13.3326 5.93027 13.3326 6.66665V9.69029L15.9514 8.17837C16.5891 7.81018 17.4045 8.02868 17.7727 8.6664C18.1409 9.30412 17.9224 10.1196 17.2847 10.4878L14.6655 11.9999L17.2848 13.5122C17.9226 13.8804 18.1411 14.6958 17.7729 15.3336C17.4047 15.9713 16.5892 16.1898 15.9515 15.8216L13.3326 14.3096V17.3333C13.3326 18.0697 12.7357 18.6666 11.9993 18.6666C11.2629 18.6666 10.666 18.0697 10.666 17.3333V14.3091L8.0471 15.8211C7.40937 16.1893 6.59392 15.9708 6.22573 15.3331C5.85754 14.6953 6.07604 13.8799 6.71376 13.5117L9.3322 11.9999L6.71389 10.4883C6.07617 10.1201 5.85767 9.30462 6.22586 8.66689C6.59405 8.02917 7.4095 7.81067 8.04723 8.17886L10.666 9.69079V6.66665C10.666 5.93027 11.2629 5.33331 11.9993 5.33331Z",
    fill: "#7B3DE9"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewSystemFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new_system_found.eaed832c973bd1d817c5d135e598ae80.svg";